/**
 * Single source of truth for the backend API base URL.
 * Production builds must set REACT_APP_API_URL to API Gateway
 * (https://….execute-api….amazonaws.com), not the UI CloudFront distribution.
 */
function normalizeBaseUrl(url) {
  if (!url || typeof url !== 'string') {
    return 'http://localhost:8000';
  }
  return url.replace(/\/$/, '');
}

export const API_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_API_URL);

/** Build a full URL for public (unauthenticated) axios calls. */
export function apiUrl(path) {
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${suffix}`;
}

if (process.env.NODE_ENV === 'production') {
  const looksLikeUiCdn =
    API_BASE_URL.includes('cloudfront.net') &&
    !API_BASE_URL.includes('execute-api');
  if (looksLikeUiCdn) {
    // eslint-disable-next-line no-console
    console.error(
      '[hockey-pipeline-ui] REACT_APP_API_URL points at CloudFront (static UI), not the API. ' +
        'Rebuild with the API Gateway endpoint from buildspec.yml.'
    );
  }
}
